import LoadingContainer from "@componentsV1/containers/LoadingContainer";
import SessionGuard from "@componentsV1/guards/SessionGuard";
import { useTypedSelector } from "@store/store";

import OAuthGuard from "./OAuthGuard";

function RootGuard({ children }: React.PropsWithChildren) {
  const isAppInitialized = useTypedSelector(
    (state) => state.session.isInitialized && state.environment.isInitialized,
  );

  return (
    <SessionGuard>
      <OAuthGuard>
        <LoadingContainer isLoading={!isAppInitialized}>{children}</LoadingContainer>
      </OAuthGuard>
    </SessionGuard>
  );
}

export default RootGuard;
